import Parse from '@/parse'
const Entry = Parse.Object.extend('Entry')
const Event = Parse.Object.extend('Event')

export default {
  retrieveEntries ({ commit }, id) {
    var query = new Parse.Query(Entry)
    query.equalTo('event', new Event({ id: id }))
    query.include('allowed')
    query.find().then((results) => {
      commit('setEntries', results)
    }).catch((error) => {
      console.log(error)
    })
  },

  async allow ({ dispatch }, entry) {
    try {
      return await Parse.Cloud.run('allowEntry', {
        id: entry.id
      })
    } catch (error) {
      dispatch(
        'snackBar/addMessage',
        error,
        { root: true }
      )
    }
  },

  async cancel ({ dispatch }, entry) {
    try {
      return await Parse.Cloud.run('cancelEntry', {
        id: entry.id
      })
    } catch (error) {
      dispatch(
        'snackBar/addMessage',
        error,
        { root: true }
      )
    }
  }
}
